import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FolderHeart, Home, Plus, Users, UserRound } from 'lucide-react';
import { cn } from '@/lib/utils';
import { fa } from '@/i18n/fa';

const navItems = [
  { to: '/', label: fa.nav.home, icon: Home, isFab: false },
  { to: '/members', label: fa.nav.members, icon: Users, isFab: false },
  { to: '/capture', label: fa.nav.capture, icon: Plus, isFab: true },
  { to: '/archive', label: fa.nav.archive, icon: FolderHeart, isFab: false },
  { to: '/profile', label: fa.nav.profile, icon: UserRound, isFab: false },
] as const;

/** Mobile bottom tab bar with a center FAB for the signature "capture" action. */
export function BottomNav() {
  return (
    <nav
      aria-label={fa.nav.home}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface/90 pb-safe backdrop-blur-md sm:hidden"
    >
      <ul className="flex items-stretch justify-between px-2">
        {navItems.map(({ to, label, icon: Icon, isFab }) => (
          <li key={to} className="flex flex-1 justify-center">
            <NavLink
              to={to}
              end={to === '/'}
              className="group flex flex-col items-center justify-center gap-1 px-2 py-2.5 text-text-subtle"
            >
              {({ isActive }) =>
                isFab ? (
                  <motion.span
                    whileTap={{ scale: 0.92 }}
                    className="-mt-7 flex size-14 items-center justify-center rounded-full bg-primary-600 text-white shadow-raised"
                  >
                    <Icon className="size-6" />
                  </motion.span>
                ) : (
                  <>
                    <span
                      className={cn(
                        'flex size-9 items-center justify-center rounded-full transition-colors',
                        isActive && 'bg-primary-50 text-primary-700',
                      )}
                    >
                      <Icon className={cn('size-5', isActive && 'text-primary-700')} />
                    </span>
                    <span
                      className={cn(
                        'h-7 text-center text-[0.7rem] font-medium leading-tight transition-colors',
                        isActive ? 'text-primary-700' : 'text-text-subtle',
                      )}
                    >
                      {label}
                    </span>
                  </>
                )
              }
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
